import styled from "styled-components";
import css from "@styled-system/css";
export const LogoBox = styled.span(
  css({
    color: "darkBold",
    fontSize: 26,
    fontWeight: "bold",
    cursor: "pointer",
    // padding: "0 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '@media (min-width: 991px)' : {
      padding: "0 10px",
    }
  })
);

export const LogoImage = styled.img({
  display: "block",
  backfaceVisibility: "visible",
  maxWidth: 150,
  objectFit: "contain",
});
